export default "__VITE_ASSET__CHRbC8YC__"